import {Component, Input, OnInit} from '@angular/core';
import {Filter} from '../../core/models/filter.model';
import {CategoriesService} from '../../core';
import {tap} from 'rxjs';
import {Category} from '../../core/models/category.model';
import {FilterService} from '../../core/services/filter.service';
import {ServerResponse} from '../../core/models/server-response.model';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '../../core/services/notification.service';
import {ErrorUtil} from '../../core/utils/error.util';
import {NotificationType} from '../../core/models/notification.model';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-filters-list',
    templateUrl: './filters.component.html',
    providers: [MessageService, ConfirmationService]
})
export class FiltersComponent implements OnInit {
    filters: Filter[] = [];
    categories: Category[] = [];
    constructor(
        private categoriesService: CategoriesService,
        private filterService: FilterService,
        private notificationService: NotificationService,
        private messageService: MessageService,
        private translate: TranslateService,
        private confirmService: ConfirmationService
    ) {
    }
    ngOnInit() {
        this.categoriesService.currentCategories.pipe(tap(cats => {
            this.categories = cats;
            this.filterService.getAll().pipe(tap( filters => this.filters = filters,
                error => this.handleError(error))).subscribe();
        }, error => this.handleError(error))).subscribe();
    }
    changeNotificationStatus(event, filter: Filter) {
        if (filter.notification_id !== undefined) {
            this.notificationService.editStatus(event.checked, filter.notification_id).pipe(tap(
                notif => filter.filter_available_only = (notif.notification_active === 1) ? 1 : 0,
                error => this.handleError(error)
            )).subscribe();
        } else {
            this.notificationService.add(NotificationType.Filter, null, null, filter.filter_id).pipe(tap(
                notif => filter.filter_available_only = (notif.notification_active === 1) ? 1 : 0,
                error => this.handleError(error)
            )).subscribe();
        }

    }
    deleteFilter(filter: Filter) {
        this.confirmService.confirm({
            message: this.translate.instant('filter_delete_prompt'),
            accept: () => {
                this.filterService.destroy(filter.filter_id).pipe(tap(data => {
                        this.messageService.add({severity: 'success', detail: this.translate.instant('filter_delete_ok')});
                        this.filters = this.filters.filter(item => item.filter_id !== filter.filter_id);
                    },
                    err => this.handleError(err)
                )).subscribe();
            },
            acceptLabel: this.translate.instant('yes'),
            rejectLabel: this.translate.instant('no')
        });
    }
    getCategoriesName(categoriesString: string) {
        let categories: any[];
        categoriesString = categoriesString + '';
        if (categoriesString.includes(',')) {
            categories = categoriesString.split(',');
        } else {
            categories = [categoriesString];
        }
        categoriesString = '';
        categories.forEach( cat => {
            if (categoriesString === '') {
                categoriesString = this.categories.filter(item => item.category_id === Number(cat))[0].category_name;
            } else {
                categoriesString += ', ' + this.categories.filter(item => item.category_id === Number(cat))[0].category_name;
            }
        });
        return categoriesString;
    }
    handleError(response: ServerResponse) {
        this.messageService.add({severity: 'error',
            summary: this.translate.instant('error'),
            detail: this.translate.instant(new ErrorUtil(response.error).description)
        });
    }
    getMinPrice(filter_min_price) {
        if (filter_min_price === undefined || filter_min_price === null) {
            return 0;
        } else {
            return filter_min_price;
        }
    }
    getMaxPrice(filter_max_price) {
        if (filter_max_price === undefined || filter_max_price === null) {
            return 500;
        } else {
            return filter_max_price;
        }
    }

}
